// useJoinCampaign.ts
import { useNavigate } from "react-router-dom";
import { toast } from "react-hot-toast";
import { useAppDispatch, useAppSelector } from "shared/hooks";
import { CampaignApiService } from ".";
import { setCampaignStats } from "store/reducer/profile";
import { useEffect } from "react";

export function useJoinCampaign() {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const campaignStats = useAppSelector(state => state.Profile.campaignStats);

  const joinCampaign = async (): Promise<boolean> => {
    try {
      const x = await CampaignApiService.JoinCampaign();

      if (x) {
        dispatch(
          setCampaignStats({
            ...campaignStats.Competition2025,
            isRegistered: true,
          })
        );

        toast.success("You've been joined successfully.", {
          style: { zIndex: 2000 },
        });

        navigate(`/en/dashboard`, { replace: true });
        return true;
      }
      return false;
    } catch {
      toast.error("Something went wrong while joining the campaign.", {
        style: { zIndex: 2000 },
      });
      return false;
    }
  };

  return { joinCampaign };
}


export const useChat = () => {
	const $window: any = window;
	useEffect(() => {
		if ($window.$crisp) return; // ✅ Prevent reloading

		$window.$crisp = [];
		$window.CRISP_WEBSITE_ID = 'ac4a5721-73d9-4a0c-98c7-7d21d71be44b';

		const script = document.createElement('script');
		script.src = 'https://client.crisp.chat/l.js';
		script.async = true;
		document.head.appendChild(script);
	}, []);
};
